import { Component, HostListener, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from "@angular/router";
import { UserService } from "../../services/user/user.service";
import { AppConstants } from 'src/app/constants/app-constants';
import { User } from 'src/app/model/User';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DialogService } from 'src/app/services/dialog/dialog.service';

/**
 * HeaderComponent represents the app header
 */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit {
  /** Whether the user clicked inside the profile section or not */
  private _clickedInside: boolean = false;

  /** The user's username */
  name: string = "";
  mail: string = "";

  /** The section of the menu that's open right now */
  menuSection: string = "";

  /**
   * Initalize services and subscribe to router changes 
   * 
   * @param _router 
   * @param _userService 
   * @param _authService 
   */
  constructor(
    private _router: Router, 
    private _userService: UserService, 
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _dialogService: DialogService,
    private _authService: AuthService,
  ) {
    // Subscribe to user changes
    this._userService.user$.subscribe(
      (user: User | null): void => {
        if (user == null) return;

        this.name = `${user.firstName} ${user.lastName}`;
        this.mail = user.email;
      });

    // Add notifications icon
    this._iconRegistry.addSvgIcon(
      'notification',
      this._sanitizer.bypassSecurityTrustResourceUrl('/assets/icons/notification.svg'),
    );
  }

  /**
   * When the component initializes get the user's name
   */
  public ngOnInit(): void {
    const user = this._userService.user;

    this.name = user == undefined ? "" : `${user.firstName} ${user.lastName}`;
  }

  /**
   * Log the user out using the auth service
   */
  public logout(): void {
    this._authService.logout();
    this._router.navigate([AppConstants.MENU_LOGIN]);
  }

  /**
   * Toggle a menu based on the provided section
   * 
   * @param section
   */
  public toggleMenu(section: string): void {
    // If the section and menu section are the same, close the menu. Otherwise, open the menu
    this.menuSection = section === this.menuSection ? "" : section;
  }

  /**
   * When the profile gets clicked, record it
   */
  clickIn() {
    this._clickedInside = true;
  }

  /**
   * When the document gets clicked and the profile did not, close the menu
   */
  @HostListener('document:click')
  clickOut() {
    // Close the menu if the user clicked outside the profile
    if (!this._clickedInside) {
      this.menuSection = "";
    }
    this._clickedInside = false;
  }

  /**
   * Open the settings modal dialog
   */
  openSettingsModal(): void {
    this._dialogService.openSettingsModal().subscribe();
  }
}
